import axios from "axios"
export function toggleAdvertismentAdvertiser(token, advertiserId, newStatus) {
    return axios.get(process.env.REACT_APP_API_URL + `/toggleAdvertisementActiveAdvertiser?advertisementId=${advertiserId}&advertisementNewStatus=${newStatus}`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}